import request from "@/utils/request";
import newRequest from "@/utils/newRequest";

const API_URL_PREFIX = "api/merchant/short_link/";

let ShortLinkService = {
  // 短链列表
  shortList(query) {
    return request({
      url: API_URL_PREFIX + "short_link/page",
      method: "post",
      params: query
    });
  },
  // 高级域名长链列表
  longList(query) {
    return request({
      url: "api/merchant/admin/short_link/short_link_config/list",
      method: "get",
      params: query
    });
  },
  // 删除链接
  deleteShort(query) {
    return request({
      url: API_URL_PREFIX + "short_link/delete",
      method: "delete",
      params: query
    });
  },
  // 短链详情
  shortDetail(query) {
    return request({
      url: API_URL_PREFIX + "short_link/detail",
      method: "get",
      params: query
    });
  },
  // 创建高级链接
  createAdvanced(query) {
    return newRequest({
      url: API_URL_PREFIX + "short_link/high/create",
      method: "post",
      data: query
    });
  },
  // 创建普通链接
  createNormal(query) {
    return request({
      url: API_URL_PREFIX + "short_link/create",
      method: "post",
      params: query
    });
  },
  // 高级版链接设置兜底链接
  setDoudiLink(query) {
    return request({
      url: API_URL_PREFIX + "short_link/high/bottom",
      method: "put",
      params: query
    });
  },
  // 高级版链接删除配置
  deleteAdvanced(query) {
    return request({
      url: API_URL_PREFIX + "short_link/high/delete",
      method: "delete",
      params: query
    });
  },
  // 新增修改高级链接单个配置
  updateChannel(query) {
    return newRequest({
      url: API_URL_PREFIX + "short_link/high/config",
      method: "post",
      data: query
    });
  },
  /**图表部分数据统计**/
  // 今日昨日一周30天统计
  dataStatistics(query) {
    return request({
      url: API_URL_PREFIX + "statTotalShortLinkData",
      method: "post",
      params: query
    });
  },
  // 流量趋势
  flowTrend(query) {
    return request({
      url: API_URL_PREFIX + "statLink",
      method: "post",
      params: query
    });
  },
  // 地域 Top10名
  territoryTop(query) {
    return request({
      url: API_URL_PREFIX + "statAreaLink",
      method: "post",
      params: query
    });
  },
  // 地域分析详情
  areaDetail(query) {
    return request({
      url: API_URL_PREFIX + "statAreaData",
      method: "post",
      params: query
    });
  },
  /**域名模块 */
  // 专属域名列表own:自有 rent:租赁
  domainList(query) {
    return request({
      url: API_URL_PREFIX + "business_domain/page",
      method: "post",
      params: query
    });
  },
  // 自有域名新增
  addDomain(query) {
    return request({
      url: API_URL_PREFIX + "business_domain/insertOwn",
      method: "post",
      params: query
    });
  },
  // 自有域名删除
  deleteDomain(query) {
    return request({
      url: API_URL_PREFIX + "business_domain/delete",
      method: "post",
      params: query
    });
  },
  // 域名下拉框
  domainSelect(query) {
    return request({
      url: API_URL_PREFIX + "domain/options",
      method: "get",
      params: query
    });
  },
  // 租赁/续费域名的下拉框
  domainRent(query) {
    return request({
      url: API_URL_PREFIX + "buy_domain/list",
      method: "post",
      params: query
    });
  },
  // 创建域名订单,支付
  createDomainOrder(query) {
    return request({
      url: "api/merchant/product-order/createDomain",
      method: "post",
      params: query
    });
  }
};

export default ShortLinkService;



// WEBPACK FOOTER //
// ./src/services/shortLink.js